/**
 * Breakpoints
*/
var viewport_3 = 320;
var viewport_4 = 480;
var viewport_7 = 768;
var viewport_9 = 992;
var viewport_10 = 1025;
var viewport_12 = 1200;
var viewport_13 = 1300;
var viewport_14 = 1440;
var viewport_16 = 1600;
var viewport_19 = 1920;

(function($) {

    $(document).ready(function() {

        if (typeof google === 'object' && typeof google.maps === 'object') {

            if($(window).width() >= viewport_9) {
                var svg_width = 197,
                    svg_height = 197,
                    anchor_point_1 = 135,
                    anchor_point_2 = 115;
            } else {
                var svg_width = 149,
                    svg_height = 149,
                    anchor_point_1 = 102,
                    anchor_point_2 = 80;
            }
        
            let map;
            let zoom = 16;
            let maxZoom = 16;
            let map_style = [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}],},{"elementType":"labels.icon","stylers":[{"visibility":"off"}],},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}],},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}],},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}],},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}],},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}],},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}],},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}],},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}],},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}],},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}],},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}],},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}],},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}],},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}],},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}],},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}],},];
            let markers = [];
        
            // let svg = '<svg width="'+svg_width+'" height="'+svg_height+'" viewBox="0 0 43 62" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.4712 0.7229C33.1309 0.7229 42.5791 10.1752 42.5791 21.8308C42.5791 30.5729 26.8954 51.9485 21.4712 61.7259C16.2711 52.3419 0.363281 30.0593 0.363281 21.8308C0.363281 10.1752 9.81561 0.7229 21.4712 0.7229ZM30.9058 21.0358C30.9058 15.8412 26.6686 11.604 21.4712 11.604C16.2779 11.604 12.0407 15.8412 12.0407 21.0358C12.0407 26.2292 16.2779 30.4663 21.4712 30.4663C26.6686 30.4663 30.9058 26.2292 30.9058 21.0358Z" fill="#855D66"/></svg>';
            let svg = '<svg width="'+svg_width+'" height="'+svg_height+'" viewBox="0 0 299 299" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.5"><path d="M149.5 298C67.6188 298 1 231.381 1 149.5C1 67.6188 67.6188 1 149.5 1C231.387 1 298 67.6188 298 149.5C298 231.381 231.387 298 149.5 298ZM149.5 11.4798C73.3975 11.4798 11.4856 73.3917 11.4856 149.494C11.4856 225.597 73.3975 287.509 149.5 287.509C225.602 287.509 287.514 225.597 287.514 149.494C287.514 73.3917 225.602 11.4798 149.5 11.4798ZM149.5 232.709C103.614 232.709 66.2848 195.381 66.2848 149.494C66.2848 103.608 103.614 66.2789 149.5 66.2789C195.386 66.2789 232.715 103.608 232.715 149.494C232.715 195.381 195.386 232.709 149.5 232.709ZM149.5 76.7704C109.398 76.7704 76.7704 109.398 76.7704 149.5C76.7704 189.602 109.398 222.23 149.5 222.23C189.602 222.23 222.23 189.602 222.23 149.5C222.23 109.398 189.602 76.7704 149.5 76.7704Z" stroke="#855D66" stroke-width="2" stroke-miterlimit="10"/></g><path d="M149.471 113.723C161.131 113.723 170.579 123.175 170.579 134.831C170.579 143.573 154.895 164.949 149.471 174.726C144.271 165.342 128.363 143.059 128.363 134.831C128.363 123.175 137.816 113.723 149.471 113.723ZM158.906 134.036C158.906 128.841 154.669 124.604 149.471 124.604C144.278 124.604 140.041 128.841 140.041 134.036C140.041 139.229 144.278 143.466 149.471 143.466C154.669 143.466 158.906 139.229 158.906 134.036Z" fill="#855D66"/></svg>';
            let icon = {
                url: 'data:image/svg+xml;base64,' + btoa(svg),
                fillColor: '#000000',
                anchor: new google.maps.Point(anchor_point_1,anchor_point_2)
            }
        
            $el = $('#js-map');

            let mapArgs = {
                zoom: zoom,
                maxZoom: maxZoom,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: map_style,
                disableDefaultUI: true
            };
            map = new google.maps.Map($el[0], mapArgs);

            // Wiardaplantage 1, Leeuwarden
            let latLng = {
                lat: 53.181170,
                lng: 5.823570
            };
        
            new google.maps.Marker({
                position: latLng,
                map: map,
                icon: icon,
                title: 'Fitz'
            });
            
            map.setCenter(latLng);
        }

    });

})(jQuery);